import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import { query, collection, getDocs, where, addDoc } from "firebase/firestore";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { Button, Input } from "reactstrap";

function AdminCreateEventPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const sports = [
    "Test",
    "Soccer",
    "Football",
    "Baseball",
    "Hockey",
    "Racing",
    "Basketball",
    "MMA",
    "College football",
    "College Basketball",
  ];

  const leagues = [
    {
      sport: "Test",
      leagues: ["Test League"],
    },
    {
      sport: "Soccer",
      leagues: [
        "Premier League",
        "LaLiga",
        "Serie A",
        "Bundesliga",
        "Ligue 1",
        "UEFA Champions League",
        "UEFA Europa League",
        "FIFA World Cup",
        "UEFA European Championship",
        "Copa America",
        "CONCACAF Gold Cup",
        "Africa Cup of Nations",
        "FIFA Club World Cup",
        "FIFA Confederations Cup",
        "FIFA U-20 World Cup",
        "FIFA U-17 World Cup",
      ],
    },
    {
      sport: "Football",
      leagues: [
        "NFL",
        "NCAA",
        "Canadian Football League",
        "Arena Football League",
        "XFL",
        "USFL",
        "NFL Europe",
        "World League of American Football",
        "United Football League",
        "Alliance of American Football",
      ],
    },
  ];

  // eslint-disable-next-line
  const [teams, setTeams] = useState([
    {
      league: "Test League",
      team: "Test team 1",
    },
    {
      league: "Test League",
      team: "Test team 2",
    },
    // {
    // 	league: 'Test League',
    // 	teams: [
    // 		'Test team 1',
    // 		'Test team 2',
    // 		'Test team 3',
    // 		'Test team 4',
    // 		'Test team 5',
    // 		'Test team 6',
    // 		'Test team 7',
    // 		'Test team 8',
    // 		'Test team 9',
    // 		'Test team 10',
    // 		'Test team 11',
    // 		'Test team 12',
    // 		'Test team 13',
    // 		'Test team 14',
    // 		'Test team 15',
    // 		'Test team 16',
    // 		'Test team 17',
    // 		'Test team 18',
    // 		'Test team 19',
    // 		'Test team 20'
    // 	]
    // },
    // {
    // 	league: 'Premier League',
    // 	teams: [
    // 		'Arsenal',
    // 		'Aston Villa',
    // 		'Brentford',
    // 		'Brighton & Hove Albion',
    // 		'Burnley',
    // 		'Chelsea',
    // 		'Crystal Palace',
    // 		'Everton',
    // 		'Leeds United',
    // 		'Leicester City',
    // 		'Liverpool',
    // 		'Manchester City',
    // 		'Manchester United',
    // 		'Newcastle United',
    // 		'Norwich City',
    // 		'Southampton',
    // 		'Tottenham Hotspur',
    // 		'Watford',
    // 		'West Ham United',
    // 		'Wolverhampton Wanderers'
    // 	]
    // },
    // {
    // 	league: 'LaLiga',
    // 	teams: [
    // 		'Alavés',
    // 		'Athletic Bilbao',
    // 		'Atlético Madrid',
    // 		'Barcelona',
    // 		'Cádiz',
    // 		'Celta Vigo',
    // 		'Eibar',
    // 		'Elche',
    // 		'Espanyol',
    // 		'Getafe',
    // 		'Granada',
    // 		'Huesca',
    // 		'Levante',
    // 		'Mallorca',
    // 		'Osasuna',
    // 		'Rayo Vallecano',
    // 		'Real Betis',
    // 		'Real Madrid',
    // 		'Real Sociedad',
    // 		'Sevilla',
    // 		'Valencia',
    // 		'Valladolid',
    // 		'Villarreal'
    // 	]
    // }
  ]);

  const [sport, setSport] = useState();
  const [league, setLeague] = useState();
  const [gameType, setGameType] = useState();
  const [homeTeam, setHomeTeam] = useState();
  const [awayTeam, setAwayTeam] = useState();
  const [matchdayAvaiableTime, setMatchdayAvailableTime] = useState();
  const [matchdayClosingTime, setMatchdayClosingTime] = useState();
  const [isStarGame, setIsStarGame] = useState();

  const createEvent = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "events"), {
        uid: uuidv4(),
        dateCreated: new Date().toISOString(),
        sport: sport,
        league: league,
        gameType: gameType,
        homeTeam: homeTeam,
        awayTeam: awayTeam,
        matchdayAvailableTime: matchdayAvaiableTime,
        matchdayClosingTime: matchdayClosingTime,
        isStarGame: isStarGame,
      });

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert(err.message);
      setIsLoading(false);
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CREATE EVENT
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Sport
        </p>
        <Input
          type="select"
          className="mainInput"
          value={sport}
          onChange={(e) => setSport(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The event's sport
          </option>
          {sports.map((sport) => {
            return <option value={sport}>{sport}</option>;
          })}
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          League
        </p>
        <Input
          type="select"
          className="mainInput"
          value={league}
          onChange={(e) => setLeague(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
          disabled={!sport}
        >
          <option value="" disabled>
            The event's league
          </option>
          {leagues.map((league) => {
            return (
              <>
                {league.sport === sport &&
                  league.leagues.map((league) => {
                    return <option value={league}>{league}</option>;
                  })}
              </>
            );
          })}
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Type
        </p>
        <Input
          type="select"
          className="mainInput"
          value={gameType}
          onChange={(e) => setGameType(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The event's type
          </option>
          <option value="Matchday">Matchday</option>
          <option value="Week gameday">Week gameday</option>
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Home team
        </p>
        <Input
          type="select"
          className="mainInput"
          value={homeTeam}
          onChange={(e) => setHomeTeam(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
          disabled={!league}
        >
          <option value="" disabled>
            The event's home team
          </option>
          {
            // eslint-disable-next-line
            teams.map((team) => {
              if (team.league === league) {
                return (
                  // eslint-disable-next-line
                  <option value={team.team} disabled={team.team == awayTeam}>
                    {team.team}
                  </option>
                );
              }
            })
          }
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Away team
        </p>
        <Input
          type="select"
          className="mainInput"
          value={awayTeam}
          onChange={(e) => setAwayTeam(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
          disabled={!league}
        >
          <option value="" disabled>
            The event's away team
          </option>
          {
            // eslint-disable-next-line
            teams.map((team) => {
              if (team.league === league) {
                return (
                  // eslint-disable-next-line
                  <option value={team.team} disabled={team.team == homeTeam}>
                    {team.team}
                  </option>
                );
              }
            })
          }
        </Input>
        {gameType === "Matchday" ? (
          <>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Matchday available time
            </p>
            <Input
              type="datetime-local"
              className="mainInput"
              value={matchdayAvaiableTime}
              onChange={(e) => setMatchdayAvailableTime(e.target.value)}
              style={{ marginBottom: "0.5rem" }}
            />
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Matchday closing time
            </p>
            <Input
              type="datetime-local"
              className="mainInput"
              value={matchdayClosingTime}
              onChange={(e) => setMatchdayClosingTime(e.target.value)}
              style={{ marginBottom: "0.5rem" }}
            />
          </>
        ) : null}
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Star game
        </p>
        <Input
          type="select"
          className="mainInput"
          value={isStarGame}
          onChange={(e) => setIsStarGame(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            Is this a star game?
          </option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </Input>
        <Button
          onClick={createEvent}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
          disabled={
            !sport ||
            !league ||
            !gameType ||
            !homeTeam ||
            !awayTeam ||
            (gameType === "Matchday" &&
              (!matchdayAvaiableTime || !matchdayClosingTime)) ||
            !isStarGame
          }
        >
          CREATE
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateEventPage;
